var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading"},[_c('h1',[_vm._v("Загрузка..."),_c('img',{attrs:{"src":require("../../assets/image/load.gif"),"alt":"loading"}})])])
}]

export { render, staticRenderFns }